import { render, staticRenderFns } from "./unitPayPackageList.vue?vue&type=template&id=668ff6c9&scoped=true&"
import script from "./unitPayPackageList.vue?vue&type=script&lang=js&"
export * from "./unitPayPackageList.vue?vue&type=script&lang=js&"
import style0 from "./unitPayPackageList.vue?vue&type=style&index=0&id=668ff6c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668ff6c9",
  null
  
)

export default component.exports